import type { ComponentProps } from 'react'
import IntakeContact from '../components/IntakeContact'

type Props = ComponentProps<typeof IntakeContact>

export default function Step1_IntakeContact(props: Props) {
  return <IntakeContact {...props} />
}

